import { useState } from "react";
import styled from "styled-components";
import Facebook from "../../assets/social-media-fb-icon-blue.svg";
import Instagram from "../../assets/social-media-ig-icon-blue.svg";
import Linkedin from "../../assets/social-media-in-icon-blue.svg";
import Spotify from "../../assets/social-media-spotify-icon-blue.svg";
import Tiktok from "../../assets/social-media-tiktok-icon-blue.svg";
import Whatsapp from "../../assets/social-media-whatsapp-icon-blue.svg";

// import {ReactComponent as Logo} from '../../assets/social-media-fb-icon.svg'

const Container = styled.div`
  width: 100%;
  .list-Links {
    color: #57769c;
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
    &__item {
      margin-right: 1rem;
    }
  }
  @media (min-width: 1024px) {
    .list-Links {
      color: white;
    }
  }
`;

const SocialMediaDropdown = () => {
  const [state] = useState({
    icons: [
      {
        name: "Facebook",
        img: Facebook,
        link: "https://www.facebook.com/MultiEdu.Australia",
      },
      {
        name: "Instagram",
        img: Instagram,
        link: "https://www.instagram.com/multiedu/?hl=en",
      },
      {
        name: "Linkedin",
        img: Linkedin,
        link: "https://www.linkedin.com/in/multi-edu-pty-ltd-student-services-agency-a12338165/",
      },
      {
        name: "Spotify",
        img: Spotify,
        link: "https://open.spotify.com/playlist/2DfRYeuyIheVOl04KLBXpt?si=YF-5RPqjQF-XAApzWmjtow&nd=1",
      },
      {
        name: "Tiktok",
        img: Tiktok,
        link: "https://www.tiktok.com/@multiedu",
      },
      {
        name: "Whatsapp",
        img: Whatsapp,
        link: process.env.REACT_APP_PHONE_NUMBER_URL,
      },
    ],
  });
  return (
    <Container>
      <ul className="list-Links">
        {state.icons.map((icon, index) => (
          <a href={icon.link} target="_blank" rel="noreferrer">
            <li className="list-Links__item" key={index}>
              <img src={`${icon.img}`} alt={icon.name} />
            </li>
          </a>
        ))}
      </ul>
    </Container>
  );
};

export default SocialMediaDropdown;
